var _rect, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_17718)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2760_17718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    width: 32,
    height: 24,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2760_17718)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.159912 0V24H32.1599V0H0.159912Z",
    fill: "#FECA00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2760_17718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.159912 0V24H32.1599V0H0.159912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2760_17718)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    width: 32,
    height: 4,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    y: 8,
    width: 32,
    height: 4,
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    y: 12,
    width: 32,
    height: 4,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    y: 20,
    width: 32,
    height: 4,
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1599 18C19.4736 18 22.1599 15.3137 22.1599 12C22.1599 8.68629 19.4736 6 16.1599 6C12.8462 6 10.1599 8.68629 10.1599 12C10.1599 15.3137 12.8462 18 16.1599 18Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8394 8.32913L12.7814 8.67628L13.8394 8.76686C13.8394 8.76686 14.0105 9.18521 13.8394 9.51179C13.796 9.5947 13.684 9.70091 13.541 9.83649C13.1208 10.235 12.4331 10.8872 12.4331 11.9467C12.4331 13.3668 15.1736 14.0107 15.1736 14.0107V14.6853C15.1736 14.6853 15.4917 14.8829 13.6769 14.8829C12.1031 14.8829 12.2015 15.4804 12.2554 15.8074C12.2637 15.8575 12.2709 15.9012 12.2709 15.9355C12.2709 16.1938 13.0273 15.6773 13.3814 15.1631C13.5678 14.8925 14.3484 14.9067 15.1495 14.981C15.2127 14.9869 15.7968 16.2242 15.2897 16.8634C15.0767 17.1319 14.341 17.1669 13.8814 17.1888C13.647 17.1999 13.4844 17.2076 13.4995 17.2412C13.5108 17.2663 13.6494 17.2581 13.8509 17.246C14.1024 17.231 14.4518 17.2102 14.7738 17.2412C14.8226 17.2459 14.6331 17.4104 14.4415 17.5767C14.2442 17.748 14.0446 17.9212 14.1008 17.9239C14.164 17.9268 14.5336 17.7221 14.8694 17.5361C15.1471 17.3822 15.4018 17.2412 15.4406 17.2412C15.694 17.2412 15.9227 17.2724 16.1234 17.2998C16.4588 17.3457 16.7156 17.3808 16.8774 17.2412C16.9271 17.1982 16.6385 17.129 16.3441 17.0585C16.0409 16.9859 15.7316 16.9118 15.7803 16.8634C16.0591 16.5867 15.9426 16.0069 15.8509 15.5503C15.8098 15.3454 15.7736 15.1653 15.7803 15.0485C15.8042 14.6337 16.2429 14.8513 16.5877 15.0223C16.7387 15.0972 16.8717 15.1631 16.944 15.1631C17.597 15.1631 16.7862 14.3372 16.3411 13.8839C16.3021 13.8442 16.2659 13.8073 16.2338 13.7741C16.0075 13.5404 16.1662 13.5718 16.5251 13.6428C16.7989 13.6969 17.1892 13.7741 17.6138 13.7741C18.5948 13.7741 19.3108 13.4554 19.062 12.5925C18.8979 12.0232 17.9995 11.8295 17.0608 11.6271C16.5767 11.5227 16.0819 11.416 15.6716 11.2543C14.6622 10.8564 14.7136 10.2763 14.7571 9.78583C14.7656 9.69043 14.7738 9.59842 14.7738 9.51179C14.7738 8.97978 15.6716 8.32913 15.6716 8.32913C15.6716 8.32913 15.2618 7.64258 14.5824 7.64258C13.9029 7.64258 13.8394 8.32913 13.8394 8.32913ZM15.6876 14.577V14.0752C15.6876 14.0752 16.1072 14.0614 16.2543 14.4143C16.4015 14.7673 15.6876 14.577 15.6876 14.577Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2368 6.71104L14.2504 7.91298L14.7753 7.78952L14.5235 6.57617L13.2368 6.71104Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5527 6.42076L14.618 8.22781L15.4835 8.01485L15.8521 6.83134L14.5527 6.42076Z",
    fill: "#FFD018"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7368 9.43867C13.928 9.43867 14.0829 9.28757 14.0829 9.10117C14.0829 8.91478 13.928 8.76367 13.7368 8.76367C13.5456 8.76367 13.3906 8.91478 13.3906 9.10117C13.3906 9.28757 13.5456 9.43867 13.7368 9.43867Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9363 6.75975L14.9286 7.96663L15.1413 8.46211L16.2925 8.00351L15.9363 6.75975Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2784 15.8942C18.2784 15.8942 20.0508 15.1024 20.0508 13.9951C20.0508 12.8878 17.1728 11.6816 17.1728 11.6816C17.1728 11.6816 15.4799 12.0691 16.2429 12.5876C17.006 13.1061 18.0283 13.3053 18.0283 13.9951C18.0283 14.6849 18.3084 15.3426 17.7406 15.3426C17.1728 15.3426 18.2784 15.8942 18.2784 15.8942Z",
    fill: "#D74800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7213 11.4785C15.7213 11.4785 15.0944 11.5886 15.1242 11.6905C15.2064 11.9719 16.0636 12.3385 16.4371 12.5924C17.2002 13.1109 17.9237 13.0526 18.4619 12.7152C19.0001 12.3778 15.7213 11.4785 15.7213 11.4785Z",
    fill: "#FFFDFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_17718"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.159912,
    width: 32,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.791e515be58b19f6c96e2ba3c10cc268.svg";
export { ForwardRef as ReactComponent };